module.exports = __webpack_public_path__ + "media/images/socials/facebook-dbb0abd8229be2c02f43d1102e1ebe44.png";